module.exports = __webpack_public_path__ + "img/clear.cb68de24.jpg";